module.exports = __webpack_public_path__ + "static/media/LogicLever5_1_2.ead6fa96.png";